import { useRef, useState } from 'react'

import { useWarehouseStockImportFile } from 'app/dataProviders/warehouse/stock/hooks'
import usePopup from 'app/common/hooks/usePopup'
import getNumEnding from 'app/common/lib/getNumEnding'
import { toFixedValueInt } from 'app/common/lib/toFixedValue'

export const WarehouseStockUpload = ({
  children,
  onSuccess,
}: {
  children: (props: {
    isUploading: boolean
    handleButtonClick: () => void
    uploadProgress: number
  }) => React.ReactNode
  onSuccess?: () => void
}) => {
  const [isUploading, setIsUploading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)

  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }

  const { upload } = useWarehouseStockImportFile({
    onUploadProgress: (e) => {
      setUploadProgress(Math.round((e.loaded * 100) / e.total))
    },
  })

  const popup = usePopup()

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return
    setIsUploading(true)
    const res = await upload({ file })
    if (res) {
      onSuccess?.()
      const { updated, errors: e } = res
      const records = getNumEnding(updated, ['запись', 'записи', 'записей'])
      const errors = getNumEnding(e.length, ['ошибка', 'ошибки', 'ошибок'])

      popup(
        e && e.length > 0
          ? `${toFixedValueInt(updated)}\u00A0${records} успешно обновлены/добавлены. ${toFixedValueInt(e.length)}\u00A0${errors}`
          : `${toFixedValueInt(updated)}\u00A0${records} успешно обновлены/добавлены`,
      )
    }
    setIsUploading(false)
    event.target.value = ''
  }

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".xlsx"
        style={{ display: 'none' }}
      />
      {children({ isUploading, handleButtonClick, uploadProgress })}
    </>
  )
}
